import { FormType } from '../../../../form-types';
import { PruritusAniFieldAnswers } from '../questions';

export const pruritusAni: FormType<PruritusAniFieldAnswers> = {
  name: 'Pruritus Ani',
  questions: [
    {
      key: 'pruritusAni_sex',
      next: {
        condition: {
          'pruritusAni_sex.female': true
        },
        key: 'pruritusAni_pregnant',
        els: 'pruritusAni_height'
      }
    },
    {
      key: 'pruritusAni_pregnant',
      next: {
        condition: {
          'pruritusAni_pregnant.yes': true
        },
        key: 'pruritusAni_trimester',
        els: 'pruritusAni_consentPregnancy'
      }
    },
    'pruritusAni_trimester',
    {
      key: 'pruritusAni_consentPregnancy',
      next: {
        condition: {
          'pruritusAni_consentPregnancy.non_consent': true
        },
        key: 'pruritusAni_nonConsent',
        els: 'pruritusAni_height'
      }
    },
    'pruritusAni_height',
    'pruritusAni_weight',
    'pruritusAni_firstItch',
    'pruritusAni_itchLocation',
    'pruritusAni_whenItchMostBothersome',
    'pruritusAni_OtherSymptoms',
    'pruritusAni_otherIssues',
    'pruritusAni_bowelMovements',
    'pruritusAni_diet',
    'pruritusAni_changedDiet',
    'pruritusAni_activityLevel',
    {
      key: 'pruritusAni_cleaningMethod',
      next: {
        condition: {
          'pruritusAni_cleaningMethod.other': true
        },
        key: 'pruritusAni_moreAboutWipeMethod',
        els: 'pruritusAni_prevTreament'
      }
    },
    'pruritusAni_moreAboutWipeMethod',
    {
      key: 'pruritusAni_prevTreament',
      next: {
        condition: {
          'pruritusAni_prevTreament.yes': true
        },
        key: 'pruritusAni_moreAboutPrevTreatment',
        els: 'pruritusAni_clothing'
      }
    },
    'pruritusAni_moreAboutPrevTreatment',
    'pruritusAni_clothing',
    'pruritusAni_sweatDuringActivity',
    {
      key: 'pruritusAni_skinCondition',
      next: {
        condition: {
          'pruritusAni_skinCondition.yes': true
        },
        key: 'pruritusAni_moreAboutSkinCondition',
        els: 'pruritusAni_contactAllergens'
      }
    },
    'pruritusAni_moreAboutSkinCondition',
    {
      key: 'pruritusAni_contactAllergens',
      next: {
        condition: {
          'pruritusAni_contactAllergens.yes': true
        },
        key: 'pruritusAni_moreAboutContactAllergens',
        els: 'pruritusAni_rectalIssues'
      }
    },
    'pruritusAni_moreAboutContactAllergens',
    'pruritusAni_rectalIssues',
    'pruritusAni_otherQuestions',
    {
      key: 'pruritusAni_consentTopicalMedication',
      next: {
        condition: {
          'pruritusAni_consentTopicalMedication.consent': true
        },
        key: 'pruritusAni_truthfulness',
        els: 'pruritusAni_nonConsent'
      }
    },
    {
      key: 'pruritusAni_truthfulness',
      next: {
        condition: {
          'pruritusAni_truthfulness.consent': true
        },
        key: 'pruritusAni_complete',
        els: 'pruritusAni_nonConsent'
      }
    },
    'pruritusAni_ineligible',
    'pruritusAni_nonConsent',
    'pruritusAni_complete'
  ]
};
